enum NotificationStatus {
    success = 'success',
    warning = 'warning',
    error = 'error',
    info = 'info',
}

export default NotificationStatus;
